window.BEAEPAGEJS = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-w3fb0tkqsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w3fb0tkq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w3fb0tkq');
        args.el = args.els[0];
        ((t) => { var o;if(new ResizeObserver(a=>{window.requestAnimationFrame(()=>{let s=t.el.querySelector(".beae__section--container .beae-grid-system")?t.el.querySelector(".beae__section--container .beae-grid-system"):t.el.querySelector(".beae__section--container");if(!s)return;let n=getComputedStyle(s).maxWidth,r=parseFloat(n.replace(/[^\d\.]*/g,"")),l=window.innerWidth;(!r||n==="100%")&&(r=1920);let c=l>768?s.offsetWidth/r<1?((s.offsetWidth-r)*1+r)/r:1:((l-428)*1+428)/428;t.el.style.setProperty("--scale-ratio",c.toString())})}).observe(t.el),(o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let s=a.target;if(!s.classList.contains("beae-grid-carousel"))return;let n=Math.round((s.scrollLeft+s.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(s.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+n+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector(".beae-section-background-video > div");if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&a){const s=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);s&&(a.innerHTML=s.html)}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w3fb0tkq: ', ex)
      };
    

      try {
        let argid = 'beae-w3fb0tkqsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w3fb0tkq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w3fb0tkq');
        args.el = args.els[0];
        ((l) => { window.BeaeSlider&&window.BeaeSlider(l) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w3fb0tkq: ', ex)
      };
    }; if (window.BEAEBASE) {window.BEAEPAGEJS()} 